import {
  CheckboxFacetGroup,
  FacetOption,
} from '@tailwindComponents/CheckboxFacetGroup';
import { RailPanel } from '@tailwindComponents/RailPanel';
import { SkuFacetState, SkuHierarchyTree as HierarchyTree } from './skuFacets';
import { SkuHierarchyTree } from './SkuHierarchyTree';

export interface SkuFacetRailProps {
  tree: HierarchyTree;
  facets: SkuFacetState;
  onSelectAll: () => void;
  onSelectUnassigned: () => void;
  onSelectCategory: (category: string) => void;
  onSelectSubCategory: (category: string, subCategory: string) => void;
  brandOptions: FacetOption[];
  onToggleBrand: (value: string) => void;
  countNoun: 'products' | 'SKUs';
}

export function SkuFacetRail({
  tree,
  facets,
  onSelectAll,
  onSelectUnassigned,
  onSelectCategory,
  onSelectSubCategory,
  brandOptions,
  onToggleBrand,
  countNoun,
}: SkuFacetRailProps) {
  return (
    <aside className='flex w-[260px] shrink-0 flex-col gap-4'>
      <p className='px-1 text-xs text-gray-400'>
        Counts show matching {countNoun}
      </p>
      <RailPanel title='Hierarchy'>
        <SkuHierarchyTree
          tree={tree}
          facets={facets}
          onSelectAll={onSelectAll}
          onSelectUnassigned={onSelectUnassigned}
          onSelectCategory={onSelectCategory}
          onSelectSubCategory={onSelectSubCategory}
        />
      </RailPanel>
      {brandOptions.length > 0 && (
        <RailPanel title='Brand'>
          <CheckboxFacetGroup
            options={brandOptions}
            selected={facets.brands}
            onToggle={onToggleBrand}
          />
        </RailPanel>
      )}
    </aside>
  );
}
